
import { Options, Prop, Vue } from 'vue-property-decorator';
import FloatingTool from './FloatingTool.vue';
import Desmos from 'desmos';

@Options({
  components: { FloatingTool },
})
export default class Calculator extends Vue {
  @Prop({ default: '' }) type: string | undefined;
  @Prop({ default: '' }) title: string | undefined;
  @Prop({ default: 400 }) width: number | undefined;
  @Prop({ default: 400 }) height: number | undefined;

  private calculator: Desmos.BasicCalculator | undefined;

  mounted() {
    this.createCalculator();
  }

  unmounted() {
    this.clear();
  }

  private handleSectionChange() {
    this.createCalculator();
  }

  private createCalculator(): void {
    this.clear();

    const element = this.$refs.container;
    switch (this.type) {
      case 'basic-calculator': {
        this.calculator = Desmos.FourFunctionCalculator(element);
        break;
      }
      case 'scientific-calculator': {
        this.calculator = Desmos.ScientificCalculator(element);
        break;
      }
      case 'graphing-calculator': {
        this.calculator = Desmos.GraphingCalculator(element);
        break;
      }
      default: {
        this.calculator = Desmos.FourFunctionCalculator(element);
        break;
      }
    }
  }

  private clear() {
    if (this.calculator) {
      this.calculator.destroy();
      this.calculator = undefined;
    }
  }
}
